import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import { apiEndpoints, apiGetByIdRequest } from "src/utils/api/api";
import {
  addCreatedAndUpdatedFields,
  addVoteStatisticField,
} from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import DescriptionIcon from "@material-ui/icons/Description";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row) => {

  return (
    <Box>
      {!row.documentNotApplicable && row.documentStructNodeId ? (
        <Tooltip title="Dokumenty">
          <IconButton
            aria-label="dokumenty"
            component={RouterLink}
            to={`/dokumenty/${row.documentStructNodeId}`}
          >
            <DescriptionIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
  );
};

const Votings = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getVotingsByStatus.path, "finished", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addVoteStatisticField(data)
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: true,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: true,
      label: "Data zakończenia",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      component: RowButtons,
    },
  ];

  const mobHeadCells = [
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      component: RowButtons,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  return (
    <Page className={classes.root} title="Głosowania zakończone">
      <Container maxWidth={false}>
        {/* <Toolbar dialogHandler={handleClickOpen} /> */}
        <Box mt={3}>
          <KmFilteredTable
            markable={false}
            headCells={headCells}
            mobHeadCells={mobHeadCells}
            rows={rows}
            onSelectedRowIdsChange={onSelectedRowIdsChanged}
            title={"Głosowania zakończone"}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(Votings);
